import { lazy, useEffect, useState } from "react";

import { Redirect, Route, useLocation } from "react-router-dom";

import { useApp } from "@ip-contexts/app-context";
import { ProtectedRoutes } from "@ip-widgets/Tailwind/auth";

const Contract = lazy(() => import("./Contract"));
const ContractEdit = lazy(() => import("./Contract/Edit"));

const Template = lazy(() => import("./Contract/Template"));
const TemplateCreate = lazy(() => import("./Contract/Template/Create"));
const TemplateEdit = lazy(() => import("./Contract/Template/Edit"));

const ContractCreate = lazy(() => import("./Contract/Create"));
const CustomContract = lazy(() => import("./Contract/CustomContract"));

const PreCreate = lazy(() => import("./Contract/PreCreate"));

export default function Legal() {
  const [loading, setLoading] = useState(true);
  const { state, dispatch } = useApp();
  const location = useLocation();

  const department = "legal";
  const departmentPath = `/${department}`;
  const isMainPath = () => location.pathname === "/" + department;

  useEffect(() => {
    if (
      (state.department !== department || state.path !== location.pathname) &&
      state.status !== "pending"
    ) {
      dispatch({
        type: "start update",
        department,
        path: location.pathname,
      });
    }
  }, [dispatch, state.department, state.status, state.path, location.pathname]);

  useEffect(() => {
    if (state.department === department && state.path === location.pathname) {
      dispatch({
        type: "finish update",
      });
    }
  }, [dispatch, state.department, state.path, location.pathname]);

  useEffect(() => {
    if (state.status === "resolved") {
      setLoading(false);
    }
  }, [state.status]);

  if (loading) {
    return <div />;
  }
  return (
    <>
      {isMainPath() && (
        <Redirect
          exact
          from={departmentPath}
          to={`${departmentPath}/contracts`}
        />
      )}

      <ProtectedRoutes path={departmentPath}>
        <Route exact component={Contract} path={"/contracts"} />
        <Route exact component={ContractCreate} path={"/contracts/new"} />
        <Route exact component={PreCreate} path={"/contracts/pre"} />

        <Route exact component={Template} path={"/templates"} />
        <Route component={TemplateCreate} path={"/templates/new"} />

        <Route component={CustomContract} path={"/contracts/custom_contract"} />

        <Route component={ContractEdit} path={"/contracts/:id"} />
        <Route component={TemplateEdit} path={"/templates/:id"} />
      </ProtectedRoutes>
    </>
  );
}
